import { memo } from 'react';
import { Button, ButtonGroup } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  button: {
    '&:hover': {
      backgroundColor: '#f5f5f5',
      color: '#1976d2'
    },
    '&.Mui-disabled': {
      backgroundColor: '#0f3d56',
      color: 'white'
    }
  }
});

export const ChatMenu = memo(({setCurrentTab, currentTab, pastChatsLength})=> {
  const classes = useStyles();
  
  return(
    <ButtonGroup size="small" aria-label="small outlined button group">
      <Button
        onClick={() => {
          setCurrentTab(0)
        }}
        disabled={currentTab === 0}
        className={classes.button}
      >
        Current Chat
      </Button>
      <Button
        disabled={!pastChatsLength || currentTab === 1}
        onClick={() => {
          setCurrentTab(1);
        }}
        className={classes.button}
      >
        Past Chats ({pastChatsLength})
      </Button>
    </ButtonGroup>
  )
}, (prevProps, nextProps)=> {
  return(
    prevProps.setCurrentTab === nextProps.setCurrentTab &&
    prevProps.currentTab === nextProps.currentTab &&
    prevProps.pastChatsLength === nextProps.pastChatsLength
  )
})